import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { CustomTable } from '../../../../shared/uiComponents';
import { TableBodyBCBA, headersBCBA } from './tableInfo';

import { DispatchProperties, useSelector } from '../../../../redux/store';
import { getActiveInsuranceAuthorizations } from '../../../../redux/State/clientSlice/insuranceAuthorizationSlice';
import { useScreenWidth } from '../../../../shared/Helpers/hooks';
import { InsuranceAuthorizationMobileCard } from './mobileCard';

const BCBAPanel = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const { clientId } = useParams();

	const userId = useSelector((state) => state.account.user.id);
	const loading = useSelector((state) => state.authorization.loading);
	const authorization = useSelector((state) => state.authorization.authorizationDetails);
	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	useEffect(() => {
		if (!clientId || !userId) return;
		dispatch(getActiveInsuranceAuthorizations({ clientId, userId }));
	}, [clientId, dispatch, userId]);

	return (
		<>
			{' '}
			{isMobile ? (
				<div className="insuranceAuthorizationMobileCardContainer">
					{authorization?.map((item) => (
						<InsuranceAuthorizationMobileCard item={item} key={item.id} />
					))}
				</div>
			) : (
				<CustomTable
					TableBody={TableBodyBCBA}
					headers={headersBCBA}
					data={{ query: authorization }}
					loading={loading}
					hasPagination={false}
				/>
			)}
		</>
	);
};

export default BCBAPanel;
